/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import SvgIconOnlineSecurity from "./OnlineSecurity";
import SvgIconAboriginalFlag from "./AboriginalFlag";
import SvgIconAccessibility from "./Accessibility";
import SvgIconAddiction from "./Addiction";
import SvgIconAdvocacy from "./Advocacy";
import SvgIconBlank from "./Blank";
import SvgIconBook from "./Book";
import SvgIconCar from "./Car";
import SvgIconCensus2016 from "./Census2016";
import SvgIconCentrelink from "./Centrelink";
import SvgIconChat from "./Chat";
import SvgIconCheckboxSelected from "./CheckboxSelected";
import SvgIconCheckboxUnselected from "./CheckboxUnselected";
import SvgIconChevronBack from "./ChevronBack";
import SvgIconChevron from "./Chevron";
import SvgIconClock from "./Clock";
import SvgIconCrossColor from "./CrossColor";
import SvgIconCross from "./Cross";
import SvgIconDemographicAboriginal from "./DemographicAboriginal";
import SvgIconDemographicAtsi from "./DemographicAtsi";
import SvgIconDemographicChildren from "./DemographicChildren";
import SvgIconDemographicCouple from "./DemographicCouple";
import SvgIconDemographicDisability from "./DemographicDisability";
import SvgIconDemographicFamilyViolence from "./DemographicFamilyViolence";
import SvgIconDemographicLgbtiq from "./DemographicLgbtiq";
import SvgIconDemographicNeedInterpreter from "./DemographicNeedInterpreter";
import SvgIconDemographicParole from "./DemographicParole";
import SvgIconDemographicPets from "./DemographicPets";
import SvgIconDemographicRecentlyArrived from "./DemographicRecentlyArrived";
import SvgIconDemographicTorresStrait from "./DemographicTorresStrait";
import SvgIconDemographicVeteran from "./DemographicVeteran";
import SvgIconEmail from "./Email";
import SvgIconEntertainment from "./Entertainment";
import SvgIconEscapeViolence from "./EscapeViolence";
import SvgIconExperiencingViolence from "./ExperiencingViolence";
import SvgIconExternalLink from "./ExternalLink";
import SvgIconFacebook from "./Facebook";
import SvgIconFacilities from "./Facilities";
import SvgIconFeedback from "./Feedback";
import SvgIconFood from "./Food";
import SvgIconHealth from "./Health";
import SvgIconHeart from "./Heart";
import SvgIconHouse from "./House";
import SvgIconInfo from "./Info";
import SvgIconInstagram from "./Instagram";
import SvgIconJob from "./Job";
import SvgIconLegal from "./Legal";
import SvgIconLightning from "./Lightning";
import SvgIconLoading from "./Loading";
import SvgIconLocation from "./Location";
import SvgIconLogoLight from "./LogoLight";
import SvgIconLogoShadow from "./LogoShadow";
import SvgIconLogo from "./Logo";
import SvgIconLogotype from "./Logotype";
import SvgIconMap from "./Map";
import SvgIconMental from "./Mental";
import SvgIconMoney from "./Money";
import SvgIconPencil from "./Pencil";
import SvgIconPhoneSolid from "./PhoneSolid";
import SvgIconPhoneTalk from "./PhoneTalk";
import SvgIconPhone from "./Phone";
import SvgIconPlus from "./Plus";
import SvgIconPolice from "./Police";
import SvgIconPrint from "./Print";
import SvgIconQuestionMarkColor from "./QuestionMarkColor";
import SvgIconRadioSelected from "./RadioSelected";
import SvgIconRadioUnselected from "./RadioUnselected";
import SvgIconSearch from "./Search";
import SvgIconSexualViolence from "./SexualViolence";
import SvgIconSkills from "./Skills";
import SvgIconSupport from "./Support";
import SvgIconTech from "./Tech";
import SvgIconThings from "./Things";
import SvgIconTickColor from "./TickColor";
import SvgIconTick from "./Tick";
import SvgIconTorresStraitIslandersFlag from "./TorresStraitIslandersFlag";
import SvgIconTram from "./Tram";
import SvgIconUnder18 from "./Under18";
import SvgIconUsingViolence from "./UsingViolence";
import SvgIconWalk from "./Walk";
import SvgIconWarning from "./Warning";
import SvgIconWebsite from "./Website";

export default {
    OnlineSecurity: SvgIconOnlineSecurity,
    AboriginalFlag: SvgIconAboriginalFlag,
    Accessibility: SvgIconAccessibility,
    Addiction: SvgIconAddiction,
    Advocacy: SvgIconAdvocacy,
    Blank: SvgIconBlank,
    Book: SvgIconBook,
    Car: SvgIconCar,
    Census2016: SvgIconCensus2016,
    Centrelink: SvgIconCentrelink,
    Chat: SvgIconChat,
    CheckboxSelected: SvgIconCheckboxSelected,
    CheckboxUnselected: SvgIconCheckboxUnselected,
    ChevronBack: SvgIconChevronBack,
    Chevron: SvgIconChevron,
    Clock: SvgIconClock,
    CrossColor: SvgIconCrossColor,
    Cross: SvgIconCross,
    DemographicAboriginal: SvgIconDemographicAboriginal,
    DemographicAtsi: SvgIconDemographicAtsi,
    DemographicChildren: SvgIconDemographicChildren,
    DemographicCouple: SvgIconDemographicCouple,
    DemographicDisability: SvgIconDemographicDisability,
    DemographicFamilyViolence: SvgIconDemographicFamilyViolence,
    DemographicLgbtiq: SvgIconDemographicLgbtiq,
    DemographicNeedInterpreter: SvgIconDemographicNeedInterpreter,
    DemographicParole: SvgIconDemographicParole,
    DemographicPets: SvgIconDemographicPets,
    DemographicRecentlyArrived: SvgIconDemographicRecentlyArrived,
    DemographicTorresStrait: SvgIconDemographicTorresStrait,
    DemographicVeteran: SvgIconDemographicVeteran,
    Email: SvgIconEmail,
    Entertainment: SvgIconEntertainment,
    EscapeViolence: SvgIconEscapeViolence,
    ExperiencingViolence: SvgIconExperiencingViolence,
    ExternalLink: SvgIconExternalLink,
    Facebook: SvgIconFacebook,
    Facilities: SvgIconFacilities,
    Feedback: SvgIconFeedback,
    Food: SvgIconFood,
    Health: SvgIconHealth,
    Heart: SvgIconHeart,
    House: SvgIconHouse,
    Info: SvgIconInfo,
    Instagram: SvgIconInstagram,
    Job: SvgIconJob,
    Legal: SvgIconLegal,
    Lightning: SvgIconLightning,
    Loading: SvgIconLoading,
    Location: SvgIconLocation,
    LogoLight: SvgIconLogoLight,
    LogoShadow: SvgIconLogoShadow,
    Logo: SvgIconLogo,
    Logotype: SvgIconLogotype,
    Map: SvgIconMap,
    Mental: SvgIconMental,
    Money: SvgIconMoney,
    Pencil: SvgIconPencil,
    PhoneSolid: SvgIconPhoneSolid,
    PhoneTalk: SvgIconPhoneTalk,
    Phone: SvgIconPhone,
    Plus: SvgIconPlus,
    Police: SvgIconPolice,
    Print: SvgIconPrint,
    QuestionMarkColor: SvgIconQuestionMarkColor,
    RadioSelected: SvgIconRadioSelected,
    RadioUnselected: SvgIconRadioUnselected,
    Search: SvgIconSearch,
    SexualViolence: SvgIconSexualViolence,
    Skills: SvgIconSkills,
    Support: SvgIconSupport,
    Tech: SvgIconTech,
    Things: SvgIconThings,
    TickColor: SvgIconTickColor,
    Tick: SvgIconTick,
    TorresStraitIslandersFlag: SvgIconTorresStraitIslandersFlag,
    Tram: SvgIconTram,
    Under18: SvgIconUnder18,
    UsingViolence: SvgIconUsingViolence,
    Walk: SvgIconWalk,
    Warning: SvgIconWarning,
    Website: SvgIconWebsite,
};
